import React, { useState } from "react";
import { ShieldAlert } from "lucide-react";

const KEY = "uc_age_ok";

export default function AgeGate() {
  const [ok, setOk] = useState(() => localStorage.getItem(KEY) === "1");
  if (ok) return null;

  const accept = () => { localStorage.setItem(KEY, "1"); setOk(true); };
  const leave = () => { window.location.href = "https://www.google.com"; };

  return (
    <div data-testid="age-gate" className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0B0F17]/95 backdrop-blur-sm px-4">
      <div className="w-full max-w-md border border-[#2A2440] bg-[#141A26] p-8 text-center text-[#120F22]">
        <img src="/uc-box-purple.png" alt="unboxcases" className="h-12 w-auto mx-auto mb-4 object-contain" draggable={false} />
        <div className="flex items-center justify-center gap-2 mb-2 text-[#FBBF24]">
          <ShieldAlert className="h-5 w-5" />
          <span className="text-xs font-bold uppercase tracking-wider">Age verification</span>
        </div>
        <h2 className="font-cases text-2xl font-extrabold mb-3">Are you 18 or older?</h2>
        <p className="text-sm text-[#9AA1B2] leading-relaxed mb-6">
          unboxcases is a real-money mystery-box platform intended for adults only. You must be at least 18
          (or the legal age in your jurisdiction) to enter. Please play responsibly.
        </p>
        <div className="flex flex-col gap-2">
          <button data-testid="age-gate-confirm" onClick={accept}
            className="w-full py-3 rounded-lg font-grotesk font-bold bg-[#9945FF] hover:bg-[#8236e6] text-white transition-colors">
            I'm 18 or older — Enter
          </button>
          <button data-testid="age-gate-decline" onClick={leave}
            className="w-full py-2.5 rounded-lg text-sm font-semibold border border-[#2A2440] text-[#9AA1B2] hover:bg-[#141021] transition-colors">
            I'm under 18 — Exit
          </button>
        </div>
        <p className="text-[10px] text-[#586074] mt-5">By entering you confirm you meet the legal age and accept our terms.</p>
      </div>
    </div>
  );
}
